export default function reportInstanceDirective() {
  return {
    template: require('./report-instance.html'),
    controller: 'GRReportInstanceController',
    controllerAs: 'grReportInstanceVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportInstance: '=',
    },
  };
}
